const namespace = 'search-ui-seo-contents';

export { namespace };
